import { motion } from 'framer-motion';

export const LoadingScreen = ({ onComplete }) => {
  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 0.4, delay: 1.8 }}
      onAnimationComplete={onComplete}
      data-testid="loading-screen"
    >
      <div className="relative flex flex-col items-center">
        {/* Vortex spiral animation */}
        <motion.div
          className="absolute w-32 h-32"
          initial={{ opacity: 0, scale: 0.5, rotate: 0 }}
          animate={{ opacity: [0, 0.3, 0], scale: [0.5, 1.5, 2], rotate: 180 }}
          transition={{ duration: 1.5, ease: 'easeOut' }}
        >
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <motion.circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke="#e62020"
              strokeWidth="1"
              strokeDasharray="0 251"
              initial={{ strokeDasharray: "0 251" }}
              animate={{ strokeDasharray: "251 0" }}
              transition={{ duration: 1.2, ease: 'easeInOut' }}
            />
          </svg>
        </motion.div>

        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          className="relative z-10"
        >
          <span className="text-4xl md:text-5xl font-bold tracking-tight" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.4 }}
              className="text-[#e62020]"
            >
              V
            </motion.span>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.5 }}
              className="text-[#e62020]"
            >
              ORTEX
            </motion.span>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.7 }}
              className="text-white"
            >
              WEBCO
            </motion.span>
          </span>
        </motion.div>

        {/* Simple underline */}
        <motion.div
          className="h-px bg-[#e62020] mt-4"
          initial={{ width: 0 }}
          animate={{ width: 60 }}
          transition={{ duration: 0.6, delay: 0.9, ease: 'easeOut' }}
        />
      </div>
    </motion.div>
  );
};
